import React, { useState } from 'react'
import { Button } from 'antd'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { WarningModal } from 'components/ui/modals/warningModal'
import { Buttons } from './styled'
import styles from './EvaluationUpdated.module.scss'

interface EvaluationUpdatedProps {
  show: boolean
  onReload: () => Promise<void>
  onClose: () => void
}

export const EvaluationUpdated: React.FC<EvaluationUpdatedProps> = ({
  show,
  onReload,
  onClose,
}) => {
  const [loading, setLoading] = useState(false)

  const handleReload = async () => {
    setLoading(true)
    await onReload()
    setLoading(false)
  }

  const t = useTranslationRankmi({
    prefix: 'lessons.contentBlocks.evaluationBlock.updated',
  })

  return (
    <WarningModal show={show} onClose={onClose} title={t('title')} width={800}>
      <div className={styles.description}>
        <strong className={styles.primary}>{t('description.primary')} </strong>
        <span className={styles.secondary}>{t('description.secondary')}</span>
        <div className={styles.note}>
          <strong>{t('description.note.subtitle')}: </strong>
          <span>{t('description.note.text')}</span>
        </div>
      </div>
      <Buttons>
        <Button onClick={handleReload} loading={loading}>
          {t('buttons.reload')}
        </Button>
      </Buttons>
    </WarningModal>
  )
}

export default EvaluationUpdated
